<div class="header-label">
    <h2>REST API Request/Response Details</h2>
</div>

<div class="filter-row">
  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>API Name</mat-label>
    <input matInput type="text" [formControl]="apiNameControl" [matAutocomplete]="apiNameControlAuto" #apiNameTrigger="matAutocompleteTrigger" placeholder="Type API name...">
    <app-autocomplete-suffix-actions
      matSuffix
      [showClear]="apiNameControl.value !== ''"
      [panelOpen]="apiNameTrigger.panelOpen"
      (clearClicked)="clearSelectedApiName($event)"
      (toggleClicked)="openOrClosePanel($event, apiNameTrigger)">
    </app-autocomplete-suffix-actions>
    <mat-autocomplete
      #apiNameControlAuto="matAutocomplete"
      [clearStaleSelectionOnOpen]="apiNameControl.value"
      [displayWith]="displayOption">
      <mat-option *ngFor="let name of filteredApiName$ | async" [value]="name">
        {{ name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>API Method</mat-label>
    <input matInput type="text" [formControl]="apiMethodControl" [matAutocomplete]="apiMethodControlAuto" #apiMethodTrigger="matAutocompleteTrigger" placeholder="Type API method...">
    <app-autocomplete-suffix-actions
      matSuffix
      [showClear]="apiMethodControl.value !== ''"
      [panelOpen]="apiMethodTrigger.panelOpen"
      (clearClicked)="clearSelectedApiMethod($event)"
      (toggleClicked)="openOrClosePanel($event, apiMethodTrigger)">
    </app-autocomplete-suffix-actions>
    <mat-autocomplete
      #apiMethodControlAuto="matAutocomplete"
      [clearStaleSelectionOnOpen]="apiMethodControl.value"
      [displayWith]="displayOption">
      <mat-option *ngFor="let method of filteredApiMethods$ | async" [value]="method">
        {{ method }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Claim Key</mat-label>
    <input matInput [(ngModel)]="filter.claimKey" placeholder="Type claim key...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Requested By</mat-label>
    <input matInput [(ngModel)]="filter.requestedBy" placeholder="Type requested by...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Requested Date From</mat-label>
    <input matInput [matDatepicker]="requestedDateFromPicker" [(ngModel)]="filter.fromRequestedDate" [required]="filter.toRequestedDate !== null" [errorStateMatcher]="dateRangeErrorStateMatcher" placeholder="Select start date">
    <mat-datepicker-toggle matIconSuffix [for]="requestedDateFromPicker"></mat-datepicker-toggle>
    <mat-datepicker #requestedDateFromPicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Requested Date To</mat-label>
    <input matInput [matDatepicker]="requestedDateToPicker" [(ngModel)]="filter.toRequestedDate" [required]="filter.fromRequestedDate !== null" [errorStateMatcher]="dateRangeErrorStateMatcher" placeholder="Select end date">
    <mat-datepicker-toggle matIconSuffix [for]="requestedDateToPicker"></mat-datepicker-toggle>
    <mat-datepicker #requestedDateToPicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Status</mat-label>
    <input
      matInput
      type="text"
      [formControl]="statusControl"
      [matAutocomplete]="statusAuto"
      #statusTrigger="matAutocompleteTrigger"
      placeholder="Search status" />
    <app-autocomplete-suffix-actions
      matSuffix
      [showClear]="statusControl.value !== ''"
      [panelOpen]="statusTrigger.panelOpen"
      (clearClicked)="clearSelectedStatus($event)"
      (toggleClicked)="openOrClosePanel($event, statusTrigger)">
    </app-autocomplete-suffix-actions>
    <mat-autocomplete
      #statusAuto="matAutocomplete"
      [clearStaleSelectionOnOpen]="statusControl.value"
      [displayWith]="displayOption">
      <mat-option *ngFor="let status of filteredStatuses$ | async" [value]="status">
        {{ status }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div class="filter-button-wrap">
    <button mat-flat-button color="primary" (click)="onFilter()">
      Filter
    </button>
  </div>

</div>

<div *ngIf="errorMessage" class="api-error-banner">
  {{ errorMessage }}
</div>

<div class="table-loader" *ngIf="loading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="table-wrapper" [class.loading]="loading">

  <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir">

    <ng-container matColumnDef="apiName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="apiName">API Name</th>
      <td mat-cell *matCellDef="let row">{{ row.APIName }}</td>
    </ng-container>

    <ng-container matColumnDef="apiMethod">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="apiMethod">API Method</th>
      <td mat-cell *matCellDef="let row">{{ row.APIMethod }}</td>
    </ng-container>

    <ng-container matColumnDef="claimKey">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="claimKey">Claim Key</th>
      <td mat-cell *matCellDef="let row">{{ row.ClaimKey }}</td>
    </ng-container>

    <ng-container matColumnDef="requestedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="requestedBy">Requested By</th>
      <td mat-cell *matCellDef="let row">{{ row.RequestedBy }}</td>
    </ng-container>

    <ng-container matColumnDef="requestedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="requestedDate">Requested Date</th>
      <td mat-cell *matCellDef="let row">{{ row.RequestedDate }}</td>
    </ng-container>

    <ng-container matColumnDef="responseDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="responseDate">Response Date</th>
      <td mat-cell *matCellDef="let row">{{ row.ResponseDate }}</td>
    </ng-container>

    <ng-container matColumnDef="s3RequestFileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="s3RequestFileName">S3 Request File Name</th>
      <td mat-cell *matCellDef="let row">{{ row.S3RequestFilename }}</td>
    </ng-container>

    <ng-container matColumnDef="s3ResponseFileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="s3ResponseFileName">S3 Response File Name</th>
      <td mat-cell *matCellDef="let row">{{ row.S3ResponseFilename }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
      <td mat-cell *matCellDef="let row">{{ row.Status }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>

  <div *ngIf="dataSource.data.length === 0" class="no-results-message">
    No records found
  </div>

</div>

<mat-paginator 
    [length]="totalCount" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" (page)="onPageChange($event)" showFirstLastButtons>
</mat-paginator>